import { Box } from '@mui/material';
import { MainChildrenContainer } from '../common/components';
import AppHeader from './components/AppHeader';
import DesktopSidebar from './components/DesktopSidebar';
import MobileNavigation from './components/MobileNavigation';
import { LAYOUT_CONFIG } from './constants/layoutConstants';
import { usePageTracking } from '../hooks/usePageTracking';

const Layout = ({ children }) => {
  usePageTracking();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <Box sx={{ display: { xs: 'block', md: 'none' }, width: '98%', margin: '0 auto' }}>
        <MobileNavigation />
      </Box>

      <Box
        sx={{
          display: { xs: 'none', md: 'block' },
          width: {
            xs: '100%',
            md: '100%',
          },
          position: 'fixed',
          zIndex: 1100,
        }}
      >
        <AppHeader />
      </Box>

      <Box sx={{ display: { xs: 'none', md: 'block' } }}>
        <DesktopSidebar />
      </Box>

      <MainChildrenContainer
        component="main"
        sx={{
          flexGrow: 1,
          width: {
            xs: '100%',
            md: 'auto',
          },
          ml: {
            xs: 'auto',
          },
          mr: {
            xs: 'auto',
          },
          mt: {
            xs: `${LAYOUT_CONFIG.mobile.headerHeight}px`,
            md: `${LAYOUT_CONFIG.desktop.headerHeight}px`,
          },
          p: { xs: 2, md: 1 },
          minHeight: {
            xs: `calc(100vh - ${LAYOUT_CONFIG.mobile.headerHeight}px)`,
            md: `calc(100vh - ${LAYOUT_CONFIG.desktop.headerHeight}px)`,
          },
          transition: 'margin 0.2s ease-in-out, width 0.2s ease-in-out',
        }}
      >
        {children}
      </MainChildrenContainer>
    </Box>
  );
};

export default Layout;
